import type { ProtectedRouteDescriptor } from '../types'

export const complianceRoutes: ProtectedRouteDescriptor[] = []
